"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function TimeFormatter(props) {
    var date = props.value;
    var formatted = "";
    if (props.show24 && date.hours() + date.minutes() + date.seconds() === 0) {
        formatted = props.short ? "24:00" : "24:00:00";
    }
    else {
        formatted = formatTime(date, props.short);
    }
    return React.createElement("span", { id: props.id }, formatted);
}
exports.TimeFormatter = TimeFormatter;
function formatTime(time, short) {
    var format = short ? "HH:mm" : "HH:mm:ss";
    return time.format(format);
}
exports.formatTime = formatTime;
